/**************************************************
 * Nombre:       Tarjeta_Categorias_Catalogo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Collapse, Grid, Typography} from "@mui/material";
import {Add} from '@mui/icons-material'
import {useState} from "react";

const Tarjeta_Categorias_Catalogo = ({item}) => {
    const [open, setOpen] = useState(false);

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography
                        onClick={() => setOpen(!open)}
                        sx={{fontSize: 14, fontWeight: 600, color: '#00000090', cursor: 'pointer'}}>
                        <Add sx={{mt: 0.7, mb: -0.7, pr: 0.5, width: 14, h: 14}}/>
                        {item}</Typography>
                </Grid>

                <Collapse in={open} sx={{width: '100%'}}>


                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{pl: 4, mt: 1}}
                        spacing={1}
                    >

                        {marcas.map((it, index) => (
                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{
                                    fontSize: 14,
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                    color: '#00000090'
                                }}>
                                    MARCA
                                </Typography>
                            </Grid>
                        ))}

                    </Grid>

                </Collapse>


            </Grid>

        </Grid>
    )

}
export default Tarjeta_Categorias_Catalogo

const marcas = [1, 2, 3, 4]